import amplitude from "amplitude-js";
declare global {
  interface Window {
    dataLayer: any[];
  }
}

window.dataLayer = window.dataLayer || [];

export type UserEvent = "click add card" | "add a card" | "login" | "add a list" | "drag a card";

export interface UserTracker {
  track: (event: UserEvent, prpoerties?: Record<string, unknown>) => void;
}

export interface UserTrackerAmplitude extends UserTracker {
  init: () => void;
  setDeviceId: (deviceID: string) => void;
}

export interface UserTrackerGoogleAnalytics extends UserTracker {}

export const UserTrackerAmplitudeImpl: UserTrackerAmplitude = {
  init: () => {
    amplitude.getInstance().init(import.meta.env.VITE_AMPLITUDE_API_KEY);
  },
  setDeviceId: (deviceId: string) => {
    amplitude.getInstance().setDeviceId(deviceId);
  },
  track: (event: UserEvent, prpoerties?: Record<string, unknown>) => {
    amplitude.getInstance().logEvent(event);
  },
};

export const UserTrackerGoogleAnalyticsImpl = {
  track: (event: UserEvent, prpoerties?: Record<string, unknown>) => {
    window.dataLayer.push({ event });
  },
};
